export default __webpack_public_path__ + "static/media/spin.90713411.gif";